import { isWrappedGetNewsByIdResponse } from 'hb-react/shared/apps/News/types';
import type {
  GetNewsResponse,
  PublishedNewsData,
} from 'hb-react/shared/apps/News/types';

export const getPublishedNewsData = (
  responseData: GetNewsResponse,
): PublishedNewsData => {
  if (isWrappedGetNewsByIdResponse(responseData)) {
    const { postCommunication } = responseData;

    const news: PublishedNewsData = {
      attachments: postCommunication.attachments,
      categories: postCommunication.categories,
      content: postCommunication.content,
      id: postCommunication.id,
      likes: postCommunication.likes,
      ogUrl: postCommunication.ogUrl,
      publishedAt:
        postCommunication.feedableAt || postCommunication.publishedAt,
      relatedLetters: postCommunication.relatedLetters,
      seoDescription: postCommunication.seoDescription,
      seoTitle: postCommunication.seoTitle,
      socialMediaList: postCommunication.socialMediaList,
      subject: postCommunication.subject,

      // Renamed properties
      seoCanonicalUrl: postCommunication.canonicalUrl || '',
      coverPicture: {
        compressedUrl: postCommunication.newCoverPicture?.compressedUrl || '',
        previewUrl: postCommunication.newCoverPicture?.previewUrl || '',
        mediumUrl: postCommunication.newCoverPicture?.mediumUrl || '',
        wideUrl: postCommunication.newCoverPicture?.wideUrl || '',
      },

      // Deprecated properties for backward compatibility
      externalUrl: postCommunication.externalUrl,

      // New properties unavailable in the old format, use sensible defaults
      uuid: '',
    };

    return news;
  }
  const news: PublishedNewsData = {
    id: responseData.id,
    uuid: responseData.uuid,
    publishedAt: responseData.publishedAt,
    seoCanonicalUrl: responseData.seoCanonicalUrl,
    seoDescription: responseData.seoDescription,
    seoTitle: responseData.seoTitle,
    socialMediaList: responseData.socialMediaList,
    content: responseData.content,
    subject: responseData.subject,
    coverPicture: responseData.coverPicture,
    attachments: responseData.attachments,
    ogUrl: responseData.ogUrl,
    categories: responseData.categories,
    likes: responseData.likes,

    // Old properties no longer available in the new format
    relatedLetters: [],
  };

  return news;
};
